let recaptchaToken: string | null = null
let recaptchaSiteKey: string | null = null

export const setRecaptchaToken = (token: string | null) => {
  recaptchaToken = token
}

export const getRecaptchaToken = () => recaptchaToken

export const setRecaptchaSiteKey = (siteKey: string | null) => {
  recaptchaSiteKey = siteKey
}

export const getRecaptchaSiteKey = () => recaptchaSiteKey
